import React from 'react';
import PropTypes from 'prop-types';
import strings from 'dibs-strings-helper';

import { RenderIn, device } from '../../utils/RenderIn';

import styles from './HpRespPersonalizationPanelSmallItem.scss';

function HpRespPersonalizationPanelSmallItem({ item, onClick }) {
    const shortTitle = strings.clampWithEllipsis(item.title, 45);

    return (
        <a href={item.pdpUrl} className={`colXs4 colXl5 ${styles.wrapper}`} onClick={onClick}>
            <div className={styles.container}>
                <img alt={item.title} className={styles.image} src={item.mainImage.thumb} />
            </div>

            <RenderIn deviceTypes={[device.DESKTOP, device.TABLET]}>
                <div className={styles.title}>{shortTitle}</div>
            </RenderIn>
        </a>
    );
}

HpRespPersonalizationPanelSmallItem.propTypes = {
    item: PropTypes.object.isRequired,
    onClick: PropTypes.func,
};

HpRespPersonalizationPanelSmallItem.defaultProps = {
    onClick: () => {},
};

export { HpRespPersonalizationPanelSmallItem };
